import { render } from "./SolucaoOrientacoesOfertaForm.vue?vue&type=template&id=71a2ce16&scoped=true"
import script from "./SolucaoOrientacoesOfertaForm.vue?vue&type=script&lang=js"
export * from "./SolucaoOrientacoesOfertaForm.vue?vue&type=script&lang=js"

import "./SolucaoOrientacoesOfertaForm.vue?vue&type=style&index=0&id=71a2ce16&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a2ce16"]])

export default __exports__